import styled from "styled-components";

export const Div = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: ${props => (props.position)};
    left: ${props => (props.left)};
    top: ${props => (props.top)};
`